module.exports = __webpack_public_path__ + "static/media/Scragg Cutter.cd86dbb8.jpg";